// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nbIL","col":"styles_col__1HHhR"};